import type { MerchantPortalRouter } from "@agent/functions/merchantPortal/index";
import { createTRPCReact } from "@trpc/react-query";
import { inferRouterOutputs, inferRouterInputs } from "@trpc/server";

export const trpc = createTRPCReact<MerchantPortalRouter>();

export type RouterOutputs = inferRouterOutputs<MerchantPortalRouter>;
export type RouterInputs = inferRouterInputs<MerchantPortalRouter>;
